import { supabase } from "./supabaseClient";

// Determine which portal a signed-in user belongs to (role isolation).
export async function resolveRole(user) {
  const email = user?.email;
  if (String(email || "").trim().toLowerCase() === "hello@simplyrefer.com.au") return "admin";
  const r = user?.user_metadata?.role;
  if (r === "clinician" || r === "clinic" || r === "gp") return r;
  if (!email) return "gp";
  const { data: clin } = await supabase.from("clinicians").select("id").eq("email", email).maybeSingle();
  if (clin) return "clinician";
  const { data: acct } = await supabase.from("accounts").select("id").eq("billing_email", email).maybeSingle();
  if (acct) return "clinic";
  return "gp";
}

export const portalPath = (role) =>
  role === "admin" ? "/admin" : role === "clinician" ? "/clinician" : role === "clinic" ? "/clinic" : "/dashboard";
